export default __webpack_public_path__ + "static/media/remote-timekeeping.f5183748.svg";